import { IAttribution } from "./attribution";

/** Applicant values collected by the form. */
export interface ILeadApplicant {
  requestedLoan: string;
  reason: string;
  ssn: string;
  email: string;
  phoneNumber: string;
  mockData?: string;
}

/**
 * Widget -> proxy BE request. Applicant field names are kept explicit; the proxy
 * maps them to the leads-hub contract (loanAmount:number, cellPhone, etc.) and
 * injects tenantKey/merchantKey from the vendor key. tenant/merchant are NOT
 * sent from the browser.
 */
export interface ILeadRequest {
  requestedLoan: string;
  reason: string;
  ssn: string;
  email: string;
  phoneNumber: string;
  utm: string;
  originationUrl: string;
  mock: any;
}

/** Parse the test-only mock JSON string; empty/invalid -> {}. */
export const parseMock = (raw?: string): any => {
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
};

export const buildLeadRequest = (
  applicant: ILeadApplicant,
  attribution: IAttribution,
): ILeadRequest => ({
  requestedLoan: applicant.requestedLoan,
  reason: applicant.reason,
  ssn: applicant.ssn,
  email: applicant.email,
  phoneNumber: applicant.phoneNumber,
  utm: attribution.utm,
  originationUrl: attribution.originationUrl,
  mock: parseMock(applicant.mockData),
});
